module.exports = __webpack_public_path__ + "img/climb.a3f1bb19.png";